/**
 * Created by mukund on 8/24/17.
 */

angular.module('mediacloudApp')
    .directive('collectionTree', function(){

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/collection/directives/collection-tree/collection-tree.html',
            scope: {
                openContent: '&',
                tree: '=',
                active: '@',
                chooseDestination: '&'
            },
            link: function(scope, element, attrs){

                scope.search = {query: ""};

                // ensures that the collection tree is only created when the tree is defined on the parent controller
                scope.$watch('tree', function(){
                    if(scope.tree) {
                        scope.treeroot = scope.tree;
                        scope.treedata = scope.tree.children;
                    }
                });

                scope.showSelected = function (sel) {
                    $('#folder-popover-trigger').popover('hide');
                    var content = {type: 'Collection', xid: sel.cid};
                    if(scope.active === 'pnp') {
                        scope.openContent({content: content});
                    } else if(scope.active === 'mediainbox') {
                        scope.chooseDestination({content: content});
                    }
                    scope.search.query = '';
                };

                scope.$watch('search.query', function () {
                    if (scope.search.query) {
                        var res = [];
                        angular.forEach(scope.treedata, function (node) {
                            getSearchResults(node, res, node);
                        });
                        scope.searchResults = angular.copy(res);
                    }
                });

                // recursive function that checks for substring matches of the search query against the titles of the collections in the collection tree
                var getSearchResults = function (node, res, parent) {
                    if (node.title && node.title.toLowerCase().indexOf(scope.search.query.toLowerCase()) !== -1) {

                        var clone = angular.copy(node),
                            pathParts = clone.path.split('/'),
                            crumbs = [],
                            parents = pathParts.slice(4);

                        if (parents.length) {
                            angular.forEach(scope.treedata, function (treenode) {
                                getCrumbs(treenode, crumbs, clone.cid, parents);
                            });
                        }

                        clone.pathLength = pathParts.length;
                        clone.parent = {title: parent.title, cid: parent.cid};
                        clone.crumbs = crumbs;

                        res.push(clone);
                    }
                    angular.forEach(node.children, function (child) {
                        getSearchResults(child, res, parent);
                    });
                };

                // recursive function that gets all parent nodes of a collection from the collection tree
                var getCrumbs = function (node, crumbs, cid, parents) {
                    if (node.cid && parents.indexOf(node.cid) !== -1) {
                        crumbs.push({title: node.title, cid: node.cid});
                    }
                    angular.forEach(node.children, function (child) {
                        getCrumbs(child, crumbs, cid, parents);
                    });
                };

                // To hide popovers when clicked anywhere else on the body
                $('body').on('click', function (e) {
                    var folderPopoverTrigger = $('#folder-popover-trigger');
                    var folderPopoverData = folderPopoverTrigger.data();
                    // hide any open popovers when the anywhere else in the body is clicked
                    if (folderPopoverData && !folderPopoverTrigger.is(e.target) && folderPopoverTrigger.has(e.target).length === 0 && $('.popover').has(e.target).length === 0 && folderPopoverData['bs.popover'].tip().hasClass('in')) {
                        scope.search.query = '';
                        scope.$apply();
                        folderPopoverTrigger.popover('hide');
                    }
                });

            }
        }
    })
    .directive('collectionTreePopover', ['$compile', '$templateCache', function($compile, $templateCache){

        return {
            restrict: "A",
            link: function (scope, element, attrs) {
                var popOverContent = $compile($templateCache.get("collection-tree.html"))(scope);
                $(element).popover({
                    content: popOverContent,
                    placement: "bottom",
                    html: true,
                    trigger: 'manual',
                    date: scope.date,
                    template: '<div class="popover folder-popover"><div class="arrow"></div><div class="popover-content"></div></div>'
                });
                $(element).on('click', function () {
                    $('#folder-popover-trigger').popover('toggle');
                    $('#folder-popover-trigger').removeAttr("aria-describedby");
                    var breadcrumb_width = $('.course-breadcrumb').children()[0].offsetWidth,
                        caret_width = $('.course-breadcrumb > .fa-caret-down')[0].offsetWidth,
                        breadcrumb_total_width = breadcrumb_width + caret_width,
                        popover_width = $('.course-breadcrumb > .popover')[0].offsetWidth,
                        delta = breadcrumb_total_width - popover_width;
                    $('.course-breadcrumb > .popover')[0].style.left = (delta > 0) ? (breadcrumb_total_width/2 + 15) + "px": 0 + "px";
                    $('.course-breadcrumb > .popover > .arrow')[0].style.left = (delta > 0) ? "50%" : breadcrumb_total_width + 14 + "px";
                });
            }
        }

    }]);
